import { useAsyncData, useNuxtData } from '#app'
import { computed } from 'vue'

import type { HttpError } from '@backmarket/http-api/src/utils/HttpApiError'

export function usePhonelineSetup<Response>(
  key: string,
  fetchSetup: () => Promise<Response>,
) {
  const { data, refresh, status, error } = useAsyncData(
    key,
    async () => {
      try {
        return await fetchSetup()
      } catch (e) {
        const err = e as HttpError

        if (err.statusCode === 404) {
          return 'empty-response'
        }

        throw err
      }
    },
    {
      getCachedData: (k, nuxtApp, ctx) => {
        if (ctx.cause === 'refresh:manual') return undefined

        return useNuxtData(k).data.value || undefined
      },
      server: false,
    },
  )

  const isEmpty = computed(() => !data.value || data.value === 'empty-response')
  const phonelineSetup = computed(() =>
    typeof data.value === 'string' ? null : data.value,
  )

  return {
    phonelineSetup,
    refresh,
    status,
    isEmpty,
    error,
  }
}
